import moment from 'moment';
import { formatTrial } from './trialPeriod';

export default function( Handlebars ) {

  Handlebars.registerHelper( 'checked', ( key, val ) => {
    return key === val ? 'checked' : '';
  });

  Handlebars.registerHelper( 'formatPhone', ( phone ) => {
    return phone.replace( /^(\d{3})(\d{3})(\d{4})/, '$1.$2.$3' );
  });

  Handlebars.registerHelper( 'formatDate', ( date, format ) => {
    return moment( date ).format( format );
  });

  Handlebars.registerHelper( 'equal', function( lvalue, rvalue, options ) {
    return options[ lvalue === rvalue ? 'fn' : 'inverse' ]( this );
  });

  Handlebars.registerHelper( 'aptFormat', ( apt ) => {
    return /\s/.test( apt ) ? apt : 'Apt ' + apt;
  });

  Handlebars.registerHelper( 'not', function( val, options ) {
    return !val ? options.fn( this ) : '';
  });

  Handlebars.registerHelper( 'stepNums', ( active, total, block ) => {
    let markup = '';

    for ( let i = 1; i <= total; i++ ) {
      const className = ( i === active ? 'active' : '' );
      markup += block.fn({ i, className });
    }
    return markup;
  });

  Handlebars.registerHelper( 'formatTrial', ( period ) => {
    return formatTrial( period ).str;
  });

  Handlebars.registerHelper( 'formatPlace', place => {
    const neighborhood = place.neighborhood;
    const borough      = place.borough;
    const city         = place.city;
    const name         = place.display_name || place.name;
    const state        = place.state;

    let locale = borough || city;

    if ( borough === 'Manhattan' ) {
      locale = 'New York';
    }

    if ( borough === 'Queens' ) {
      locale = neighborhood || 'Queens';
    }

    return `${ name }, ${ locale }, ${ state }`;
  });

}
